import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import './CategoryCaption.scss'

const CategoryCaption = (slides) => {

  const [listOpen, setListOpen] = useState(false)
  const { pathname } = useLocation()
  const toggleList = () => setListOpen(!listOpen)

    return ({ data: { title, category } = {} }) => (
      <div
        className={`project-category__caption ${listOpen ? 'project-category__caption--open' : ''}`}
      >
        <span className="project-category__category">
          <span>Projects :: </span>
          { category }
        </span>
        <span className="project-category__name">{ title }</span>
        { slides &&
          <ul
            className={`project-category__list ${listOpen ? 'project-category__list--open' : ''}`}
          >
            {slides.map(({ slug, title:projectTitle }, index) => (
              <li
                key={`${slug}-${index}`}
                className={`project-category__list-item ${title === projectTitle ? 'project-category__list-item--selected' : ''}`}
              >
                <Link to={`${pathname}/${slug}`}>
                  {projectTitle}
                </Link>
              </li>
            ))}
          </ul>
        }
        <button
          onClick={ toggleList }
          className="project-category__toggle"
        >
          { listOpen ? 'hide' : 'show'} Project List
        </button>
      </div>
    )
}

export default CategoryCaption